var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("잠시만 기다려 주세요. 앱으로 이동 중입니다...")]),_c('div',{staticClass:"item-info",on:{"click":_vm.openAOSAppOrStore}},[_vm._v("AOS앱 열기")]),_c('div',{staticClass:"item-info",on:{"click":_vm.openIOSAppOrStore}},[_vm._v("IOS앱 열기")])])}
var staticRenderFns = []

export { render, staticRenderFns }